/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, useEffect, useState } from 'react'
import Contact from './contact'
import Copyright from './copyright'
import BurgerButton from './burger'
import Header from './header'
import '../styles/main.scss'
import Sidebar from './sidebar'
import { SiteMetadataI } from '../types/data-models'

interface LayoutI {
  data: {
    site: {
      siteMetadata: SiteMetadataI
    }
  }
  location: Location
  isSinglePost: boolean
}

const Layout: FC<LayoutI> = ({ children, location, data, isSinglePost }) => {
  const { social, title, menuLinks, contact } = data.site.siteMetadata

  const [showMenu, setShowMenu] = useState(false)
  const [menuAlt, setMenuAlt] = useState(false)

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    return () => window.removeEventListener('scroll', handleScroll)
  })

  const handleScroll = () => {
    if (window.scrollY >= 617) {
      if (!menuAlt) {
        setMenuAlt(true)
      }
    } else {
      if (menuAlt) {
        setMenuAlt(false)
      }
    }
  }

  const toggleMenu = () => {
    setShowMenu(!showMenu)
  }

  return (
    <div id="layout" className={showMenu ? 'is-navPanel-visible' : ''}>
      <div id="wrapper">
        <Header location={location} siteMetadata={data.site.siteMetadata} isSinglePost={isSinglePost} />
        <div id="main">{children}</div>
        {contact && social && <Contact contact={contact} social={social} />}
        {title && <Copyright title={title} />}
        <div className="bg fixed" style={{ transform: 'none' }} />
      </div>
      {menuLinks && menuLinks.length > 0 && social && (
        <Sidebar menuLinks={menuLinks} toggleMenu={toggleMenu} social={social} />
      )}
      <a id="navPanelToggle" onClick={toggleMenu} className={menuAlt ? 'alt' : ''}>
        <BurgerButton />
      </a>
    </div>
  )
}

export default Layout
